/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { greetingModelSchema } from "../greetingModelSchema.ts";
import { z } from "zod";

export const getApiGreetingsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор шаблона")
    })

/**
 * @description Шаблон приветственного экрана
 */
export const getApiGreetingsId200Schema = z.lazy(() => greetingModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiGreetingsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiGreetingsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiGreetingsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Шаблон приветственного экрана не найден
 */
export const getApiGreetingsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiGreetingsId500Schema = z.lazy(() => badResponseModelSchema)

export const getApiGreetingsIdQueryResponseSchema = z.lazy(() => getApiGreetingsId200Schema)